// Style for stripes inputs.
// This style need because we can only add style when create stripe inputs.
// We can do this only in js.
export const inputStyles = {
    style: {
        base: {
            color: '#000',
            fontSmoothing: 'antialiased',
            fontSize: '15px',
            '::placeholder': {
                color: '#AFB3BD'
            },
            ':-webkit-autofill': {
                color: '#AFB3BD',
            },
        },
        invalid: {
            color: '#fa755a',
            iconColor: '#fa755a',
            ':-webkit-autofill': {
                color: '#fa755a',
            },
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/creditCard/contants.js